import { SessionMentor } from '../../types/mentor'
import { CaseIcon } from '../Icons'

interface AvatarDetailsProps {
  mentor: SessionMentor
  title?: string
  className?: string
}

export default function AvatarDetails({
  mentor,
  className,
  title,
}: AvatarDetailsProps) {
  return (
    <div
      className={`tc-mv-blur p-4 rounded-regular w-[40%] text-white mb-8 ${
        className || ''
      }`}
    >
      <div className="md:text-[30px] leading-none font-bold mb-1">
        {title || (
          <span className="capitalize">{`${mentor?.firstName} ${mentor?.lastName}`}</span>
        )}
      </div>
      <p className="text-xs md:text-lg font-bold leading-[150%] mb-1">
        {title ? (
          <>
            with{' '}
            <span className="capitalize">{`${mentor?.firstName} ${mentor?.lastName}`}</span>
          </>
        ) : (
          mentor?.call_to_action || mentor?.headline
        )}
      </p>
      <div className="flex items-center gap-2 whitespace-nowrap flex-wrap text-[10px] md:text-[16px]">
        <div className="flex items-center gap-1">
          <CaseIcon size={16} />
          {mentor.jobTitle}
        </div>
      </div>
    </div>
  )
}
